<template>
  <header class="header flex column">
    <div class="header_container flex ai jcs">
      <div></div>
      <div class="flex">
        <img @click="jumpToExternal('天猫')" class="tianmao pointer" src="@/assets/header/tianmao.svg" />
        <div class="vertical"></div>
        <img @click="jumpToExternal('京东')" class="jingdong pointer" src="@/assets/header/jingdong.svg" />
      </div>
    </div>
    <div class="dividing_line"></div>
    <div class="navigationBar flex ai jcs">
      <div class="flex">
        <img @click="jumpToThePage('首页')" class="logo pointer" src="@/assets/header/logo.svg" />
        <div @click="productFamily" class="productFamily flex ai pointer">
          <div class="navigationBar-title">产品家族</div>
          <img class="iconExpand" :style="showPopUp ? 'transform: rotate(180deg);' : ''" src="@/assets/header/iconExpand.svg" alt="" />
        </div>
        <div @click="jumpToThePage('畅销明星')" class="productFamily flex ai pointer">
          <div class="navigationBar-title">畅销明星</div>
          <div v-if="pageName === '畅销明星'" class="selectBar"></div>
        </div>
        <div @click="jumpToThePage('关于')" class="productFamily flex ai pointer">
          <div class="navigationBar-title">关于One A Day®</div>
          <div v-if="pageName === '关于'" class="selectBar"></div>
        </div>
      </div>
      <img class="logoBayer" src="@/assets/header/logoBayer.svg" alt="" />
    </div>
    <transition name="fade">
      <div v-if="showPopUp" class="popUp-productFamily flex">
        <img class="popupImg" src="@/assets/header/popupImg.png" alt="" />
        <div class="popupTitleBox flex column">
          <!-- <img class="popupTitle1" src="@/assets/header/popupTitle1.png" alt="" /> -->
          <img @click="enterProduct('专业营养')" class="popupTitle2 pointer" src="@/assets/header/popupTitle2.png" alt="" />
          <img @click="enterProduct('基础营养')" class="popupTitle3 pointer" src="@/assets/header/popupTitle3.png" alt="" />
          <img @click="enterProduct('果味营养')" class="popupTitle4 pointer" src="@/assets/header/popupTitle4.png" alt="" />
        </div>
      </div>
    </transition>
  </header>
  <div v-if="showPopUpJump" class="popup flex ai jcc">
    <div class="popup-content flex column ai">
      <div class="popup-title default">您正在离开One A Day官网页面</div>
      <div class="popup-contentTxt1 default">你已选择进入第三方网站，你将离开拜耳所属的网站并去往第三方独立运营并不被拜耳管理的网络平台。拜耳将不对上述网站的内容及运营承担任何责任。</div>
      <div class="popup-contentTxt2 default">点击“取消”返回当前One A Day网页，点击“继续”访问第三方网站。</div>
      <div class="btnBox flex jcs">
        <div @click="jumpExternal" class="btnContinue flex ai jcc pointer">继续</div>
        <div @click="showPopUpJump = false" class="btnCancel flex ai jcc pointer">取消</div>
      </div>
    </div>
  </div>
</template>

<script setup>
import { ref, watch, onMounted } from "vue";
import { useRouter, useRoute } from "vue-router";
const router = useRouter();
const route = useRoute();
const showPopUp = ref(false);
watch(
  () => route.path, // 可以监听 route.path, route.params, route.query 等
  (newPath, oldPath) => {
    // console.log("路由从", oldPath, "变更为", newPath);
    // 在这里执行路由变化后的逻辑
    if (newPath == "/bestSellingStar") {
      pageName.value = "畅销明星";
    } else if (newPath == "/about") {
      pageName.value = "关于";
    } else {
      pageName.value = "首页";
    }
  }
);

onMounted(() => {
  window.addEventListener("resize", () => {
    if (route.path == "/bestSellingStar") {
      pageName.value = "畅销明星";
    } else if (route.path == "/about") {
      pageName.value = "关于";
    } else {
      pageName.value = "首页";
    }
  });
});

// 跳转页面名称
const pageName = ref("");
const jumpToThePage = (name) => {
  showPopUp.value = false;
  pageName.value = name;
  if (name == "首页") {
    router.push("/");
  } else if (name == "畅销明星") {
    router.push("/bestSellingStar");
  } else if (name == "关于") {
    router.push("/about");
  }
};
// 产品家族点击事件
const productFamily = () => {
  showPopUp.value = !showPopUp.value;
};
// 进入产品页面
const enterProduct = (type) => {
  showPopUp.value = false;
  router.replace({ name: "Product", query: { type: type } });
};
// 是否展示跳转弹窗
const showPopUpJump = ref(false);
// 跳转名称
const jumpName = ref("");
// 跳转外部网站
const jumpToExternal = (name) => {
  showPopUpJump.value = true;
  jumpName.value = name;
};
const jumpExternal = () => {
  if (jumpName.value == "天猫") {
    window.open("https://oneaday.tmall.hk/shop/view_shop.htm?spm=pc_detail.29232929.shop_block.dshopinfo.48c67dd6wiDCEV", "_blank");
    showPopUpJump.value = false;
  } else if (jumpName.value == "京东") {
    window.open("https://mall.jd.hk/index-1000107607.html", "_blank");
    showPopUpJump.value = false;
  }
};
</script>

<style lang="scss" scoped>
.popup {
  position: fixed;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  background: rgba(0, 0, 0, 0.5);
  z-index: 10000;
}
.popup-content {
  padding: 0.62rem 0.4rem 0.5rem 0.4rem;
  box-sizing: border-box;
  background: #ffffff;
  border-radius: 0.1rem;
}
.popup-title {
  font-family: SourceHanSansSC-Bold;
  font-weight: bold;
  font-size: 0.38rem;
  color: #13104c;
  text-align: center;
}
.popup-contentTxt1 {
  margin-top: 0.26rem;
  width: 6.45rem;
  font-family: SourceHanSansSC-Regular;
  font-weight: 400;
  font-size: 0.2rem;
  color: #13104c;
  line-height: 0.32rem;
}
.popup-contentTxt2 {
  margin-top: 0.16rem;
  width: 6.45rem;
  font-family: SourceHanSansSC-Regular;
  font-weight: 400;
  font-size: 0.2rem;
  color: #13104c;
}
.btnContinue {
  width: 1.31rem;
  height: 0.5rem;
  border-radius: 0.03rem 0.03rem 0.03rem 0.03rem;
  border: 0.01rem solid #13104c;
  font-family: SourceHanSansSC-Regular;
  font-weight: 400;
  font-size: 0.3rem;
  color: #000000;
}
.btnCancel {
  width: 1.31rem;
  height: 0.5rem;
  background: #13104c;
  border-radius: 0.03rem;
  font-family: SourceHanSansSC-Regular;
  font-weight: 400;
  font-size: 0.3rem;
  color: #ffffff;
}
.btnBox {
  margin-top: 0.46rem;
  width: 3.67rem;
}
.header {
  width: 100%;
  height: 1.97rem;
  background: #13104c;
  position: relative;
}
.header_container {
  height: 0.7rem;
  padding: 0 0.3rem;
  box-sizing: border-box;
}
.tianmao {
  width: 1.42rem;
  height: 0.22rem;
}
.vertical {
  margin-left: 0.22rem;
  width: 0.03rem;
  height: 0.22rem;
  background: #ffffff;
}
.jingdong {
  margin-left: 0.22rem;
  width: 1.57rem;
  height: 0.24rem;
}
.dividing_line {
  width: 100%;
  height: 2px;
  background: #ffffff;
}
.navigationBar {
  width: 100%;
  flex: 1;
  padding: 0 0.33rem 0 0.43rem;
  box-sizing: border-box;
}
.logo {
  width: 170px;
  height: 69px;
}
.productFamily {
  position: relative;
  margin-left: 0.94rem;
}
.navigationBar-title {
  font-family: SourceHanSansSC-Bold;
  font-weight: bold;
  font-size: 24px;
  color: #ffffff;
}
.iconExpand {
  margin-left: 0.02rem;
  width: 0.19rem;
  height: 0.13rem;
}
.about {
  width: 1.89rem;
  height: 0.27rem;
}
.popUp-productFamily {
  position: absolute;
  top: 1.97rem;
  width: 100%;
  height: 4.4rem;
  background: #ffffff;
  z-index: 1;
  padding: 0.5rem 0 0 1.46rem;
  box-sizing: border-box;
}
.popupImg {
  width: 3.05rem;
  height: 3.9rem;
  zoom: 1;
}
.popupTitleBox {
  margin-left: 1.21rem;
}
.popupTitle1 {
  margin-top: 0.3rem;
  width: 0.69rem;
  height: 0.354rem;
  zoom: 1.2;
}
.popupTitle2 {
  margin-top: 0.46rem;
  width: 2.46rem;
  height: 0.54rem;
  zoom: 1;
  transform-origin: left;
  transition: transform 0.3s;
}
.popupTitle2:hover {
  transform: scale(1.2);
  /* 放大1.1倍 */
}
.popupTitle3 {
  margin-top: 0.37rem;
  width: 1.66rem;
  height: 0.53rem;
  zoom: 1;
  transform-origin: left;
  transition: transform 0.3s;
}
.popupTitle3:hover {
  transform: scale(1.2);
  /* 放大1.1倍 */
}
.popupTitle4 {
  margin-top: 0.4rem;
  width: 1.71rem;
  height: 0.58rem;
  zoom: 1;
  transform-origin: left;
  transition: transform 0.3s;
}
.popupTitle4:hover {
  transform: scale(1.2);
  /* 放大1.1倍 */
}
/* 淡入淡出动画 */
.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.5s ease;
}

.fade-enter-from,
.fade-leave-to {
  opacity: 0;
}

.selectBar {
  position: absolute;
  top: 55px;
  width: 100%;
  height: 6px;
  background: #ffffff;
}
.logoBayer {
  width: 0.88rem;
  height: 0.88rem;
}
</style>
